import { AuthTokenStorage } from '../../types'

export const useRefreshTokenState = (storage: AuthTokenStorage) => {
  const getRefreshToken = storage.get
  const setRefreshToken = storage.set
  return [getRefreshToken, setRefreshToken] as const
}
